export default __webpack_public_path__ + "static/media/podium.431f293b.svg";